import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { NavShell } from "@/components/NavShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Registry from "@/pages/Registry";
import PatientFile from "@/pages/PatientFile";
import Tasks from "@/pages/Tasks";
import Reports from "@/pages/Reports";
import Appointments from "@/pages/Appointments";
import Analytics from "@/pages/Analytics";
import KnowledgeLibrary from "@/pages/KnowledgeLibrary";
import StyleLibrary from "@/pages/StyleLibrary";
import LiveAgent from "@/pages/LiveAgent";
import ClinicPrep from "@/pages/ClinicPrep";
import RPISManager from "@/pages/RPISManager";
import RPISDueRemindersPage from "@/pages/RPISDueReminders";
import NotFound from "@/pages/NotFound";

function Protected({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center text-slate-400">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <Protected>
            <NavShell />
          </Protected>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="registry" element={<Registry />} />
        <Route path="patients/:id" element={<PatientFile />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="reports" element={<Reports />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="live-agent" element={<LiveAgent />} />
        <Route path="clinic-prep" element={<ClinicPrep />} />
        <Route path="knowledge" element={<KnowledgeLibrary />} />
        <Route path="style" element={<StyleLibrary />} />
        <Route path="rpis-manager" element={<RPISManager />} />
        <Route path="rpis-manager/due-reminders" element={<RPISDueRemindersPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
